import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import * as ACL from 'domain/restriction';

import Route404 from 'pages/servicePage/page404';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';

interface RestrictedRouteProps {
  children: ReactNode;
  restriction: any;
  waitForSelector?: (state: any) => boolean;
}

const defaultSelector = () => true;

const RestrictedRoute: React.FC<RestrictedRouteProps> = ({ children, restriction, waitForSelector }) => {
  const restrictions = useSelector(ACL.myRestriction);
  const ACLFilterFN = ACL.arrayFilter(restrictions);
  const isAvailable = ACLFilterFN({ restriction });

  const isRouteReady = useSelector(waitForSelector || defaultSelector);

  // Only show loading if a custom selector was provided and data is not ready
  if (waitForSelector && !isRouteReady) {
    return (
      <Box sx={{ width: '100%' }}>
        <LinearProgress />
      </Box>
    );
  }

  if (!isAvailable && isRouteReady) {
    return <Route404 />;
  }

  return <>{children}</>;
};

export default RestrictedRoute;
